import React from "react";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

export default function chennaiPlant() {
  return (
    <div className="slider-wrapper">
      <div className="container">
        <div className="row mt63">
          <div className="col-sm-12">
            <div className="mainbdr whitebg">
              <div className="row">
                <div className="col-sm-3">
                  <Sidebar />
                </div>
                <div class="col-sm-9 " style={{ marginTop: "5px" }}>
                  <div class="row mt0">
                    <div class="col-sm-12">
                      <div class="inner_content">
                        <h2>Chennai Plant</h2>

                        <div class="row">
                          <div class="col-sm-6">
                            <img
                              src="../images/Tamilnadu-Chennai.jpg"
                              class="img-responsive"
                            />
                          </div>
                          <div class="col-sm-6">
                            <div class="address">
                              <ul>
                                <li>
                                  <img src="../images/person.png" />{" "}
                                  <span>Contact Person Name : </span> Shri M.
                                  Lakshminarayanan
                                </li>
                                <li>
                                  <img src="../images/desi.png" />{" "}
                                  <span>Designation : </span> General Manager
                                  Incharge
                                </li>
                                <li>
                                  <img src="../images/home-icon.png" />{" "}
                                  <span>Address : </span> Nandambakkam,
                                  Chennai-600089 (Tamil Nadu)
                                </li>
                                <li>
                                  <img src="../images/cell_icon.gif" />{" "}
                                  <span>Telephone : </span> 9841058246
                                </li>
                                <li>
                                  <img src="../images/mouse_icon.gif" />{" "}
                                  <span>E-mail : </span>
                                  sriml@rediffmail.com
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <br />

                        <p>
                        IDPL (TN) Ltd was situated at Nandambakkam, on the Chennai-Bangalore Poonamallee high road, Chennai atop the Adyar River.
                        </p>
                        <p>
                        It was initially commissioned in 1965 to manufacture Surgical Instruments. In March 1994  the unit was converted into a 100% Subsidiary of IDPL  as IDPL (TN) Ltd. The Surgical Instruments plant had been non- operational since 2001.
                        </p>
                        <p>
                        The plant was diversified into production of Formulations in 1978-79 with large capacity for production of Tablets and capsules supported by well equipped Quality Control Department.. The Formulation Division also remained non operational since 2018. At present, the Plant is nonexistent and the Company is under closure.
                        </p>
                        <br />

                        <div class="clearfix"></div>

                        <div class="">
                          <iframe
                            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15548.885142209589!2d80.1927227!3d13.0215757!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x8340bc0ccbe63744!2sIndian+Drugs+%26+Pharmaceuticals+Ltd!5e0!3m2!1sen!2sin!4v1450349267256"
                            width="100%"
                            height="250"
                            frameborder="0"
                            style={{ border: "0;" }}
                            allowfullscreen
                          ></iframe>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <Footer />
            </div>

            <div className="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
